import { HalfedgeDS } from "../core/HalfedgeDS";
import { Vertex } from "../core/Vertex";

export function connectRing(struct: HalfedgeDS, verts: Vertex[], wrap: boolean) {
  const L = verts.length;
  const stop = wrap ? L : L - 1;
  for (let i = 0; i < stop; i++) {
    const a = verts[i];
    const b = verts[(i + 1) % L];
    if (!a.isConnectedToVertex(b)) struct.addEdge(a, b, false);
  }
}